import { createDisposable } from '@app/packages/disposable/disposable'

export class EventBus<EventType = unknown> {
  listeners: { value: (data: EventType) => unknown }[] = []

  on(listener: (data: EventType) => unknown) {
    const val = { value: listener }
    this.listeners.push(val)
    return createDisposable(() => {
      this.listeners = this.listeners.filter(l => l !== val)
    })
  }

  dispatch(e: EventType) {
    this.listeners.forEach(l => l.value(e))
  }
}
